import React from 'react';

import { StyledDots } from './Dots.styles';

import { DotsProps } from './Dots.types';

import { Dot } from '../Dot';

const Dots = ({
  componentClassname = 'dots-list',
  customClassnames = '',
  dotComponentClassname,
  dotComponentCustomClassname,
  renderDotFunction,
  dotSrOnlyTextFunction,
  numberOfDots,
  currentSlideIndex,
  sliderDispatch,
  ...props
}: DotsProps) => {
  const dots = [];

  for (let dotIndex = 0; dotIndex < numberOfDots; dotIndex++) {
    dots.push(
      <li key={dotIndex} className={`${componentClassname}__item`}>
        <Dot
          componentClassname={dotComponentClassname}
          customClassnames={dotComponentCustomClassname}
          isSelected={currentSlideIndex === dotIndex}
          index={dotIndex}
          sliderDispatch={sliderDispatch}
          children={renderDotFunction ? renderDotFunction(dotIndex) : null}
          srOnlyTextFunction={dotSrOnlyTextFunction}
        />
      </li>,
    );
  }
  return (
    <StyledDots
      {...props}
      className={`${componentClassname} ${customClassnames}`}
    >
      {dots}
    </StyledDots>
  );
};
Dots.displayName = 'Dots';

export default Dots;
